export let sliderInterval;
export function homeInit() {

    let userInteracted = false;
    let _keyAnimationValues = {
        'relax': 0,
        'enhance': 90,
        'explore': 180,
        'heighten': 270
    };

    // let nextHeroSlideThrottled = throttle(nextHeroSlide, 1200);
    let nextHeroSlideDebounced = debounce(nextHeroSlide, 500, true);

    // Set hero container height
    let sliderHeight = 0;
    $('#hero-slider .slide').each(function(index, obj) {
        if ($(obj).height() > sliderHeight) {
            sliderHeight = $(obj).height();
            $('#hero-slider').css('height', sliderHeight);
        }
    });

    // Hero slider until user interaction
    // clearInterval(sliderInterval);
    sliderInterval = setInterval(function() { 
        if (userInteracted) {
            clearInterval(sliderInterval);
        } else {
            nextSlide();
        }
    }, 4000);

    $('.hero-pager span').on('click', function(e) {
        e.preventDefault;
        userInteracted = true;

        if (!$(this).hasClass('active')) {
            nextHeroSlideDebounced(this);
        }
    });

    $('.hero-pager .arrow.right').on('click', function(e) {
        userInteracted = true;
        nextSlide();
    });

    $('.hero-pager .arrow.left').on('click', function(e) {
        userInteracted = true;
        prevSlide();
    });

    // Quick swipe enable on mobile
    let mc = new Hammer(document.getElementById('hammer-swiper'));
    mc.get('pan').set({ threshold: 130 });
    let lastSwipe = new Date();
    mc.on("panleft panright", function(ev) {
        // Looks swapped, but needs to be for swipe to feel natural
        if (ev.type == "panleft") {
            $('.hero-pager .arrow.right').click();
            
        } else if (ev.type == "panright") {
            $('.hero-pager .arrow.left').click();
        }
    });

    function nextSlide() {
        let colorId = parseInt($('.hero-pager span.active').attr('data-id'), 10);
        colorId += 1;

        // 0 starting array. Max is 5
        if (colorId >= 6) {
            colorId = 0;
        }

        nextHeroSlideDebounced($(`.hero-pager span[data-id='${colorId}']`));
    }

    function prevSlide() {
        let colorId = parseInt($('.hero-pager span.active').attr('data-id'), 10);
        colorId -= 1;

        // 0 starting array. Max is 5
        if (colorId <= -1) {
            colorId = 5;
        }

        nextHeroSlideDebounced($(`.hero-pager span[data-id='${colorId}']`));
    }

    function nextHeroSlide(pager) {
        let colorName = $(pager).attr('data-class');
        let colorId = $(pager).attr('data-id');
        let keyName = $(pager).attr('data-key');

        // Update pager active state
        $('.hero-pager span').removeClass('active');
        $(pager).addClass('active');

        // Update Hero BG
        $('.hero .bg').removeClass('active');
        $('.hero .bg.bg-' + colorName).addClass('active');

        // Animate text
        $('#hero-slider .slide.active').addClass('fade-out');
        $(`#hero-slider .slide[data-id=${colorId}]`).addClass('active');

        // Update main class
        $('#home-wrapper').removeClass('blue red green yellow purple orange').addClass(colorName);

        // Update product image
        $('.hero .img-products .img-product').removeClass('active');
        $('.hero .img-products .img-product.img-' + colorName).addClass('active');

        // Animate key
        if (keyName) {
            rotateKey(keyName);

            $('svg.key.dynamic .active').removeClass('active');
            $(`svg.key.dynamic .${keyName}`).addClass('active');
        } else {
            $('svg.key.dynamic .active').removeClass('active');
        }

        setTimeout(function() {
            $('#hero-slider .slide.active.fade-out').removeClass('fade-out').removeClass('active');
            // $('#home-pager').addClass('can-animate');
        }, 900);
    }

    function rotateKey(name) {
        $('.key-wrapper .dynamic').css('transform', `rotate(${_keyAnimationValues[name]}deg)`);
    }

    $('#age-verification-no').on('click', function() {
        $('.age-verification .ask').css('display', 'none');
        $('.age-verification .too-young').css('display', 'block');
    });

    $('#age-verification-yes').on('click', function() {
        $('.age-verification').removeClass('show');
    });


    /***********************/
    /** HELPFUL FUNCTIONS **/
    /***********************/

    // A (possibly faster) way to get the current timestamp as an integer.
    // var now = Date.now || function() {
    //     return new Date().getTime();
    // };

    // Returns a function, that, when invoked, will only be triggered at most once
    // during a given window of time. Normally, the throttled function will run
    // as much as it can, without ever going more than once per `wait` duration;
    // but if you'd like to disable the execution on the leading edge, pass
    // `{leading: false}`. To disable execution on the trailing edge, ditto.
    // function throttle(func, wait, options) {
    //     var timeout, context, args, result;
    //     var previous = 0;
    //     if (!options) options = {};

    //     var later = function() {
    //         previous = options.leading === false ? 0 : now();
    //         timeout = null;
    //         result = func.apply(context, args);
    //         if (!timeout) context = args = null;
    //     };

    //     var throttled = function() {
    //         var _now = now();
    //         if (!previous && options.leading === false) previous = _now;
    //         var remaining = wait - (_now - previous);
    //         context = this;
    //         args = arguments;
    //         if (remaining <= 0 || remaining > wait) {
    //             if (timeout) {
    //                 clearTimeout(timeout);
    //                 timeout = null;
    //             }
    //             previous = _now;
    //             result = func.apply(context, args);
    //             if (!timeout) context = args = null;
    //         } else if (!timeout && options.trailing !== false) {
    //             timeout = setTimeout(later, remaining);
    //         }
    //         return result;
    //     };

    //     throttled.cancel = function() {
    //         clearTimeout(timeout);
    //         previous = 0;
    //         timeout = context = args = null;
    //     };

    //     return throttled;
    // }

    //*************//
    //** DEBOUNE **//
    //*************//

    // Some functions take a variable number of arguments, or a few expected
    // arguments at the beginning and then a variable number of values to operate
    // on. This helper accumulates all remaining arguments past the function’s
    // argument length (or an explicit `startIndex`), into an array that becomes
    // the last argument. Similar to ES6’s "rest parameter".
    function restArguments(func, startIndex) {
        startIndex = startIndex == null ? func.length - 1 : +startIndex;
        return function() {
            var length = Math.max(arguments.length - startIndex, 0),
                rest = Array(length),
                index = 0;
            for (; index < length; index++) {
                rest[index] = arguments[index + startIndex];
            }
            switch (startIndex) {
                case 0:
                    return func.call(this, rest);
                case 1:
                    return func.call(this, arguments[0], rest);
                case 2:
                    return func.call(this, arguments[0], arguments[1], rest);
            }
            var args = Array(startIndex + 1);
            for (index = 0; index < startIndex; index++) {
                args[index] = arguments[index];
            }
            args[startIndex] = rest;
            return func.apply(this, args);
        };
    }

    // Delays a function for the given number of milliseconds, and then calls
    // it with the arguments supplied.
    var delay = restArguments(function(func, wait, args) {
        return setTimeout(function() {
            return func.apply(null, args);
        }, wait);
    });

    // When a sequence of calls of the returned function ends, the argument
    // function is triggered. The end of a sequence is defined by the ‘wait’ 
    // parameter. If ‘immediate’ is passed, the argument function will be 
    // triggered at the beginning of the sequence as well. 
    function debounce(func, wait, immediate) {
        var timeout, result;

        var later = function(context, args) {
            timeout = null;
            if (args) result = func.apply(context, args);
        };

        var debounced = restArguments(function(args) {
            if (timeout) clearTimeout(timeout);
            if (immediate) {
                var callNow = !timeout;
                timeout = setTimeout(later, wait);
                if (callNow) result = func.apply(this, args);
            } else {
                timeout = delay(later, wait, this, args);
            }

            return result;
        });

        debounced.cancel = function() {
            clearTimeout(timeout);
            timeout = null;
        };

        return debounced;
    }
}